export default {"src":"/developer/_next/static/media/dzen.92106b54.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};